// Validação de perfil para assinatura

export interface ProfileData {
  full_name?: string | null;
  cpf?: string | null;
  phone?: string | null;
  address_zipcode?: string | null;
  address_street?: string | null;
  address_number?: string | null;
  address_complement?: string | null;
  address_neighborhood?: string | null;
  address_city?: string | null;
  address_state?: string | null;
  pagarme_customer_id?: string | null;
}

export interface ValidationResult {
  valid: boolean;
  missing: string[];
}

export function validateProfileForSubscription(profile: ProfileData): ValidationResult {
  const required = [
    { field: 'full_name', label: 'Nome completo' },
    { field: 'cpf', label: 'CPF' },
    { field: 'phone', label: 'Telefone' },
    { field: 'address_zipcode', label: 'CEP' },
    { field: 'address_street', label: 'Endereço' },
    { field: 'address_number', label: 'Número' },
    { field: 'address_neighborhood', label: 'Bairro' },
    { field: 'address_city', label: 'Cidade' },
    { field: 'address_state', label: 'Estado' },
  ];

  const missing = required
    .filter(r => {
      const value = profile[r.field as keyof ProfileData];
      return !value || (typeof value === 'string' && value.trim() === '');
    })
    .map(r => r.label);

  return {
    valid: missing.length === 0,
    missing,
  };
}
